import { render } from "./mped-amortization-main-asset-view.vue?vue&type=template&id=3c36245c"
import script from "./mped-amortization-main-asset-view.vue?vue&type=script&setup=true&lang=js"
export * from "./mped-amortization-main-asset-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/mped/views/amortization/main-asset/mped-amortization-main-asset-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c36245c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c36245c', __exports__)) {
    api.reload('3c36245c', __exports__)
  }
  
  module.hot.accept("./mped-amortization-main-asset-view.vue?vue&type=template&id=3c36245c", () => {
    api.rerender('3c36245c', render)
  })

}


export default __exports__